/* Soutelo Ask-AI. Initialises every [data-soutelo-askai] block on the page. */
(function () {
  var TARGETS = [
    { id: 'chatgpt',    label: 'ChatGPT',    build: function (q) { return 'https://chatgpt.com/?q=' + q; } },
    { id: 'claude',     label: 'Claude',     build: function (q) { return 'https://claude.ai/new?q=' + q; } },
    { id: 'perplexity', label: 'Perplexity', build: function (q) { return 'https://www.perplexity.ai/search?q=' + q; } },
    { id: 'google',     label: 'Google AI',  build: function (q) { return 'https://www.google.com/search?udm=50&q=' + q; } },
    { id: 'copilot',    label: 'Copilot',    build: function (q) { return 'https://copilot.microsoft.com/?q=' + q; } },
    { id: 'lechat',     label: 'Le Chat',    build: function (q) { return 'https://chat.mistral.ai/chat?q=' + q; } },
    { id: 'grok',       label: 'Grok',       build: function (q) { return 'https://grok.com/?q=' + q; } }
  ];

  function readJSON(root, sel) {
    var el = root.querySelector(sel);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function init(root) {
    if (root.getAttribute('data-askai-ready') === '1') return;
    root.setAttribute('data-askai-ready', '1');

    var context = readJSON(root, '[data-askai-context]') || '';
    var prompt = readJSON(root, '[data-askai-prompt]') || '';
    var rawEnabled = readJSON(root, '[data-askai-enabled]') || '';
    var enabled = String(rawEnabled).split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);

    var q = encodeURIComponent(prompt);
    if (q.length > 1500) {
      var m = prompt.match(/https?:\/\/\S+/);
      q = encodeURIComponent(prompt.slice(0, 850) + ' Full details: ' + (m ? m[0] : ''));
    }

    var linkWrap = root.querySelector('[data-askai-links]');
    if (linkWrap) {
      linkWrap.innerHTML = '';
      TARGETS.forEach(function (t) {
        if (enabled.length && enabled.indexOf(t.id) === -1) return;
        var a = document.createElement('a');
        a.href = t.build(q);
        a.target = '_blank';
        a.rel = 'noopener nofollow';
        a.textContent = t.label;
        a.setAttribute('data-askai-target', t.id);
        linkWrap.appendChild(a);
      });
    }

    var preview = root.querySelector('[data-askai-preview]');
    if (preview) preview.textContent = context;

    var btn = root.querySelector('[data-askai-copy]');
    var status = root.querySelector('[data-askai-status]');
    if (!btn) return;

    btn.addEventListener('click', function () {
      var done = function () {
        btn.textContent = btn.getAttribute('data-done');
        if (status) status.textContent = '';
        setTimeout(function () { btn.textContent = btn.getAttribute('data-label'); }, 2400);
      };
      var fallback = function () {
        var ta = document.createElement('textarea');
        ta.value = context;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); done(); }
        catch (e) {
          if (status) status.textContent = 'Select the text below and copy it manually.';
          var d = root.querySelector('.soutelo-askai__details');
          if (d) d.open = true;
        }
        document.body.removeChild(ta);
      };
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(context).then(done).catch(fallback);
      } else {
        fallback();
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-soutelo-askai]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
